<template>
  <div class="wallet-connector">
    <div class="set" v-if="!currentWallet" @click="showModal = true">
      <i class="iconfont icon-licai"></i><span>{{ $t("notAnZ") }}</span>
    </div>

    <popover
      v-model="showPopover"
      placement="bottom-end"
      trigger="click"
      theme="dark"
      :actions="actions"
      @select="onSelect"
      v-else
    >
      <template #reference>
        <div class="set">
          <i class="iconfont icon-licai"></i>
          <span>{{ shortenAddress(currentWallet.address) }}</span>
        </div>
      </template>
    </popover>

    <div v-if="showModal" class="wallet-modal">
      <div class="modal-content">
        <div
          v-for="wallet in wallets"
          :key="wallet.catalogId"
          @click="onWalletClick(wallet)"
          class="wallet-button"
          :class="{ disabled: !wallet.info.uuid }"
        >
          <div class="left">
            <img
              v-if="wallet.info.icon"
              :src="wallet.info.icon"
              :alt="wallet.info.name"
              class="wallet-icon"
            />
            {{ wallet.info.name }}
          </div>
          <div class="status" v-if="wallet.info.uuid">installed</div>
        </div>
        <div @click="showModal = false" class="cancel">{{ $t("quxiao") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { walletManager } from "../utils/walletManager";
import {
  createWalletOptionsForUi,
  findInstalledProvider,
  WALLET_OPTIONS,
} from "../utils/walletCatalog";
import { Popover } from "vant";
export default {
  data() {
    return {
      showModal: false,
      availableWallets: [],
      currentWallet: null,

      wallets: createWalletOptionsForUi(),
      showPopover: false,
      actions: [{ text: this.$t('logout'), value: "1" }],
    };
  },
  components: { Popover },
  async created() {
    window.addEventListener(
      "walletManager:providersChanged",
      this.updateWalletList
    );
    this.updateWalletList();
    await walletManager.checkIfConnected();
    this.currentWallet = walletManager.currentWallet;
    this.updateWalletList();
  },

  beforeDestroy() {
    window.removeEventListener(
      "walletManager:providersChanged",
      this.updateWalletList
    );
  },

  methods: {
    updateWalletList() {
      const availableWallets = Array.from(walletManager.providers.values());
      this.wallets.forEach((wallet) => {
        const catalogEntry = WALLET_OPTIONS.find(
          (entry) => entry.catalogId === wallet.catalogId
        );
        if (!catalogEntry) return;

        const matched = findInstalledProvider(catalogEntry, availableWallets);
        if (matched) {
          wallet.info = {
            ...wallet.info,
            ...matched.info,
            icon: wallet.info.icon || matched.info.icon,
          };
        } else {
          const { uuid, ...rest } = wallet.info;
          wallet.info = { ...rest };
          delete wallet.info.uuid;
        }
      });
    },

    onWalletClick(wallet) {
      if (!wallet.info.uuid) return;
      this.connect(wallet.info.uuid);
    },

    async connect(uuid) {
      try {
        this.currentWallet = await this.$wallet.connectWallet(uuid);
        this.showModal = false;
        this.$emit("connected", this.currentWallet);
      } catch (error) {
        this.$emit("error", error);
      }
    },

    disconnect() {
      if (this.currentWallet) {
        this.$wallet.disconnectWallet(this.currentWallet.uuid);
        this.currentWallet = null;
        this.$emit("disconnected");
      }
    },

    handleAccountsChanged(accounts) {
      if (accounts.length === 0) {
        this.disconnect();
      }
    },

    shortenAddress(address) {
      if (!address) return "";
      return `${address.slice(0, 5)}...${address.slice(-4)}`;
    },
    onSelect(action) {
      this.disconnect();
    },
    handleCommand(e) {
      const that = this;
      switch (e) {
        case "routeUser":
          that.routeUser();
          break;
        case "disconnectMetaMask":
          that.disconnect();
          break;
        default:
          break;
      }
    },
    routeUser() {
      console.log("object");
      this.$router.push("/user");
    },
  },
};
</script>

<style scoped lang="scss">
.connect {
  border-radius: 10px 10px 10px 10px;
  width: 147px;
  height: 38px;
  color: #000;
  text-align: center;
  line-height: 38px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 20px;
    height: 20px;
  }
}
.icon-licai{
  color: #7338FF;
}
.wallet-connector {
  position: relative;
  display: flex;
  align-items: center;
}

.wallet-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  height: 100vh;
}

.modal-content {
  background: rgba(255, 255, 255);
  backdrop-filter: blur(30px);
  border-radius: 15px;
  padding: 20px;
  max-width: 500px;
  width: 100%;
}
.wallet-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  cursor: pointer;
  padding: 0 10px;
  &:hover {
    background: rgba(1, 1, 1, 0.1) !important;
  }
  .left {
    display: flex;
    align-items: center;
    font-size: 26px;
    color: #000;
  }
  &:first-child {
    border-bottom: 1px solid #eee;
  }
  &.disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
}
.status {
  color: #999;
  font-size: 26px;
}
.cancel {
  height: 70px;
  background-color: #333;
  border-radius: 16px;
  text-align: center;
  line-height: 70px;
  margin-top: 20px;
  cursor: pointer;
  color: #fff;
}
.wallet-icon {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}

.connected-wallet {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wallet-address {
  font-family: monospace;
}
.set {
  border-radius: 18px;
  opacity: 1;
  display: flex;
  align-items: center;
  padding: 8px 30px;
  box-sizing: border-box;
  font-size: 26px;
  cursor: pointer;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.08);

  i {
    margin-right: 10px;
    font-size: 28px;
  }
}
</style>
